import _createForOfIteratorHelper from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { Circle, Constants, ExternalInteractorBase, Rectangle, Vector } from "../../../Core";
import { calcEasing, clamp, divMode, divModeExecute, getDistances, isDivModeEnabled, isInArray } from "../../../Utils";
export var Repulser = /*#__PURE__*/function (_ExternalInteractorBa) {
  _inherits(Repulser, _ExternalInteractorBa);

  var _super = _createSuper(Repulser);

  function Repulser(container) {
    _classCallCheck(this, Repulser);

    return _super.call(this, container);
  }

  _createClass(Repulser, [{
    key: "isEnabled",
    value: function isEnabled() {
      var container = this.container,
          options = container.actualOptions,
          mouse = container.interactivity.mouse,
          events = options.interactivity.events,
          divs = events.onDiv,
          divRepulse = isDivModeEnabled("repulse", divs);

      if (!(divRepulse || events.onHover.enable && mouse.position || events.onClick.enable && mouse.clickPosition)) {
        return false;
      }

      var hoverMode = events.onHover.mode,
          clickMode = events.onClick.mode;
      return isInArray("repulse", hoverMode) || isInArray("repulse", clickMode) || divRepulse;
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function () {
      var _interact = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var container, options, mouseMoveStatus, events, hoverEnabled, hoverMode, clickEnabled, clickMode, divs;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                container = this.container, options = container.actualOptions, mouseMoveStatus = container.interactivity.status === Constants.mouseMoveEvent, events = options.interactivity.events, hoverEnabled = events.onHover.enable, hoverMode = events.onHover.mode, clickEnabled = events.onClick.enable, clickMode = events.onClick.mode, divs = events.onDiv;

                if (mouseMoveStatus && hoverEnabled && isInArray("repulse", hoverMode)) {
                  this.hoverRepulse();
                } else if (clickEnabled && isInArray("repulse", clickMode)) {
                  this.clickRepulse();
                } else {
                  divModeExecute("repulse", divs, function (selector, div) {
                    return _this.singleSelectorRepulse(selector, div);
                  });
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function interact() {
        return _interact.apply(this, arguments);
      }

      return interact;
    }()
  }, {
    key: "singleSelectorRepulse",
    value: function singleSelectorRepulse(selector, div) {
      var _this2 = this;

      var container = this.container,
          query = document.querySelectorAll(selector);

      if (!query.length) {
        return;
      }

      query.forEach(function (item) {
        var elem = item,
            pxRatio = container.retina.pixelRatio,
            pos = {
          x: (elem.offsetLeft + elem.offsetWidth / 2) * pxRatio,
          y: (elem.offsetTop + elem.offsetHeight / 2) * pxRatio
        },
            repulseRadius = elem.offsetWidth / 2 * pxRatio,
            area = div.type === "circle" ? new Circle(pos.x, pos.y, repulseRadius) : new Rectangle(elem.offsetLeft * pxRatio, elem.offsetTop * pxRatio, elem.offsetWidth * pxRatio, elem.offsetHeight * pxRatio),
            divs = container.actualOptions.interactivity.modes.repulse.divs,
            divRepulse = divMode(divs, elem);

        _this2.processRepulse(pos, repulseRadius, area, divRepulse);
      });
    }
  }, {
    key: "hoverRepulse",
    value: function hoverRepulse() {
      var container = this.container,
          mousePos = container.interactivity.mouse.position;

      if (!mousePos) {
        return;
      }

      var repulseRadius = container.retina.repulseModeDistance;
      this.processRepulse(mousePos, repulseRadius, new Circle(mousePos.x, mousePos.y, repulseRadius));
    }
  }, {
    key: "processRepulse",
    value: function processRepulse(position, repulseRadius, area, divRepulse) {
      var _a;

      var container = this.container,
          query = container.particles.quadTree.query(area),
          repulseOptions = container.actualOptions.interactivity.modes.repulse;

      var _iterator = _createForOfIteratorHelper(query),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var particle = _step.value;

          var _getDistances = getDistances(particle.position, position),
              dx = _getDistances.dx,
              dy = _getDistances.dy,
              distance = _getDistances.distance,
              velocity = ((_a = divRepulse === null || divRepulse === void 0 ? void 0 : divRepulse.speed) !== null && _a !== void 0 ? _a : repulseOptions.speed) * repulseOptions.factor,
              repulseFactor = clamp(calcEasing(1 - distance / repulseRadius, repulseOptions.easing) * velocity, 0, repulseOptions.maxSpeed),
              normVec = Vector.create(distance === 0 ? velocity : dx / distance * repulseFactor, distance === 0 ? velocity : dy / distance * repulseFactor);

          particle.position.addTo(normVec);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "clickRepulse",
    value: function clickRepulse() {
      var container = this.container;

      if (!container.repulse.finish) {
        if (!container.repulse.count) {
          container.repulse.count = 0;
        }

        container.repulse.count++;

        if (container.repulse.count === container.particles.count) {
          container.repulse.finish = true;
        }
      }

      if (container.repulse.clicking) {
        var repulseDistance = container.retina.repulseModeDistance,
            repulseRadius = Math.pow(repulseDistance / 6, 3),
            mouseClickPos = container.interactivity.mouse.clickPosition;

        if (mouseClickPos === undefined) {
          return;
        }

        var range = new Circle(mouseClickPos.x, mouseClickPos.y, repulseRadius),
            query = container.particles.quadTree.query(range);

        var _iterator2 = _createForOfIteratorHelper(query),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var particle = _step2.value;

            var _getDistances2 = getDistances(mouseClickPos, particle.position),
                dx = _getDistances2.dx,
                dy = _getDistances2.dy,
                distance = _getDistances2.distance,
                d = Math.pow(distance, 2),
                velocity = container.actualOptions.interactivity.modes.repulse.speed,
                force = -repulseRadius * velocity / d;

            if (d <= repulseRadius) {
              container.repulse.particles.push(particle);
              var vect = Vector.create(dx, dy);
              vect.length = force;
              particle.velocity.setTo(vect);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      } else if (container.repulse.clicking === false) {
        var _iterator3 = _createForOfIteratorHelper(container.repulse.particles),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _particle = _step3.value;

            _particle.velocity.setTo(_particle.initialVelocity);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        container.repulse.particles = [];
      }
    }
  }]);

  return Repulser;
}(ExternalInteractorBase);